"use client";
import { useEffect, useState } from "react";

type DebounceOptions<T> = {
  onDebouncedValueChange?: (debouncedValue: T) => void;
  updateFaultyValues?: boolean;
};

export function useDebounce<T>(
  value: T,
  delayMs: number = 300,
  options?: DebounceOptions<NoInfer<T>>,
): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (value || options?.updateFaultyValues) {
      if (value != debouncedValue) {
        const handler = setTimeout(() => {
          setDebouncedValue(value);
          options?.onDebouncedValueChange &&
            options.onDebouncedValueChange(value);
        }, delayMs);
        return () => {
          clearTimeout(handler);
        };
      }
    }
  }, [delayMs, value]);

  return debouncedValue;
}
